<div class="column">
  <div class="row" style="justify-content: space-between;">
    <range-selector style="padding: 20px 20px 0 80px;flex-grow:1;"></range-selector>
    @if (chart_component!=='custom-chart' && estimate_list?.length > 0) {
      <mat-form-field
        style="margin:10px 10px 0 0;">
        <mat-label>Select estimate</mat-label>
        <mat-select (selectionChange)="changeEstimate($event)" [ngModel]="selected_estimate">
          @for (estimate of estimate_list; track estimate) {
            <mat-option
            [value]="estimate">{{estimate.attributes | nameOrDescription}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  <div style="position: relative;">
    @if (data_ready && config) {
      <generic-chart [config]="config" class="chart"></generic-chart>
    }
  </div>

</div>
<div class="comment-button">
  <button
    (click)="headerData.toggleCommentPanel(!headerData.showing_comments, {tileData:tileData, eventService:eventService})"
    [ngClass]="{'show-drawer': headerData.showing_comments}"
    class="icon-comment">
  </button>
</div>
